export default __webpack_public_path__ + "static/media/OtherVenues.176b3030.png";